import LazyLoad from "vanilla-lazyload";
import lax from 'lax.js';
import Glide from '@glidejs/glide';
import CookiesEuBanner from 'cookies-eu-banner';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';


window.addEventListener('load', (e) => {
  //preloader
  const preLoader = document.querySelector(".pre-loader");
  preLoader.classList.add("hide");

  //lax scroll
  lax.setup(); // init

  const updateLax = () => {
    lax.update(window.scrollY);
    window.requestAnimationFrame(updateLax);
  };
  window.requestAnimationFrame(updateLax);

  //lazy load
  var lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazy",
  });

  //slider
  const sliders = document.querySelectorAll('.glide');
  const conf = {
    animationDuration: 800,

  }
  sliders.forEach(item => {
    new Glide(item, conf).mount();
  })

  const slidersAuto = document.querySelectorAll('.glideAuto');
  const confAuto = {
    autoplay: 5000,
    animationDuration: 800,

  }
  slidersAuto.forEach(item => {
    new Glide(item, confAuto).mount();
  })
})

//show nav bar on scroll
const mediaQuery = window.matchMedia('(min-width: 992px)');
const nav = document.getElementById('nav');
const navHeight = 58
const mobileHeader = document.getElementById('mobile-header');
const mobileNavHeight = 50

function showNavBarOnScroll(event) {
  window.addEventListener('scroll', (scollEvent) => {
    if (event.matches) {
      console.log("matches");
      if (window.pageYOffset > window.innerHeight - navHeight) {
        nav.classList.add('show');
      } else {
        nav.classList.remove('show');
      }
    } else {
      console.log("does not match");
      if (window.pageYOffset > window.innerHeight - mobileNavHeight) {
        mobileHeader.classList.add('show');
      } else {
        mobileHeader.classList.remove('show');
      }
    }
  })
  if (!event.matches) {
    nav.classList.remove('show');
  }
}

showNavBarOnScroll(mediaQuery);

//burger click
const burgerMobileHeader = document.getElementById('mobile-header-burger');
burgerMobileHeader.addEventListener('click', e => {
  nav.classList.toggle('show');
  burgerMobileHeader.classList.toggle('active');
})

/* popup */
//body-scroll-lock
// const disableBodyScroll = bodyScrollLock.disableBodyScroll;
// const enableBodyScroll = bodyScrollLock.enableBodyScroll;

const modalTriggers = document.querySelectorAll('.popup-trigger')
const modalCloseTrigger = document.querySelector('.popup-modal__close')
const bodyBlackout = document.querySelector('.body-blackout')
modalTriggers.forEach(trigger => {
  trigger.addEventListener('click', () => {
    const { popupTrigger } = trigger.dataset
    const popupModal = document.querySelector(`[data-popup-modal="${popupTrigger}"]`)
    popupModal.classList.add('is--visible')
    bodyBlackout.classList.add('is-blacked-out')

    disableBodyScroll(popupModal);


    popupModal.querySelector('.popup-modal__close').addEventListener('click', () => {
      popupModal.classList.remove('is--visible')
      bodyBlackout.classList.remove('is-blacked-out');

      enableBodyScroll(popupModal);

    })

    bodyBlackout.addEventListener('click', () => {
      popupModal.classList.remove('is--visible')
      bodyBlackout.classList.remove('is-blacked-out');

      enableBodyScroll(popupModal);

    })

  })
})

//accordion
// Listen for click on the document
document.addEventListener('click', function (event) {

  //Bail if our clicked element doesn't have the class
  if (!event.target.classList.contains('accordion-header')) return;

  // Get the target content
  var content = document.querySelector(event.target.hash);
  if (!content) return;

  // Prevent default link behavior
  event.preventDefault();

  // If the content is already expanded, collapse it and quit
  if (content.classList.contains('active')) {
    content.classList.remove('active');
    return;
  }

  // Get all open accordion content, loop through it, and close it
  var accordions = document.querySelectorAll('.accordion-body.active');
  for (var i = 0; i < accordions.length; i++) {
    accordions[i].classList.remove('active');
  }

  // Toggle our content
  content.classList.toggle('active');
})

//Cookie
//cookie consent
let mapsConsent = document.getElementById('maps-disclaimer');
let mapsConsentButton = document.getElementById('load-maps');
let googleMaps = document.getElementById('google-maps');
let dataSrcGoogle = googleMaps.getAttribute('data-src');


mapsConsentButton.addEventListener('click', event => {
	event.preventDefault();
	changeGoogleMaps();
  setCookie('mapsLoaded', 'true', 30);
})

if(getCookie("mapsLoaded") == "true") {
  changeGoogleMaps();
}

function changeGoogleMaps() {
  mapsConsent.classList.add('hide');
	googleMaps.src = dataSrcGoogle;
}

//YouTube Videos
const allYouTubeVideos = document.querySelectorAll('.youtube-video');
const youtubeConsent = document.createElement('div');
youtubeConsent.classList.add('youtubeConsent');
youtubeConsent.innerHTML = `
<p>
Dieses Video wurde von YouTube eingebettet.<br>
Es gelten die Datenschutzerklärungen von YouTube.
</p>
<button class="load-youtube">YouTube Video laden</button>
`;
let dataSrcYoutube = "";

allYouTubeVideos.forEach(youTubeVideo => {
  youTubeVideo.after(youtubeConsent)
  dataSrcYoutube = youTubeVideo.getAttribute('data-src');
})
let youtubeConsentButton = document.querySelectorAll('button.load-youtube');

youtubeConsentButton.forEach(button => {
  button.addEventListener('click', event => {
    event.preventDefault();
    changeYouTubeVideo();
    setCookie('youTubeLoaded', 'true', 30);
  })
})

if(getCookie("youTubeLoaded") == "true") {
  changeYouTubeVideo()
}

function changeYouTubeVideo() {
  youtubeConsent.classList.add('hide');
	allYouTubeVideos.forEach(youTubeVideo => {
    youTubeVideo.src = dataSrcYoutube;
    youTubeVideo.classList.add('show');
  })
}

new CookiesEuBanner(function () {
	changeGoogleMaps();
  changeYouTubeVideo();
}, true);

//cookie meta
function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}